// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"1fd05948","732":"71cdf3a7","881":"2556d6ab"}[chunkId] + ".chunk.js";
};